import constants from './constants.js.es6';
import typeUtils from './utils/typeUtils.js.es6';
import helpers from './utils/helpers.js.es6';

let { filterContext } = constants;

export default class CompanyHelper {
    constructor(props){
        this.name = 'Company Helper'
    }

    static setPageTitle = (companyName) => {
        let title = document.getElementsByTagName('title')[0];

        if(title){
            title.innerHTML = 'My Booklists | ' + (companyName !== null ? companyName + ' | ' : '') + 'Booklist Manager';
        }
    };

    /**
     * Get ALL Companies
     * - Returns a flattened array of de-nested parent/child companies
     *
     * @param companies
     * @returns Array[{company}]
     */
    static getAllCompanies(companies){
        return helpers.sort(
            companies.reduce((list, company) => {
                if(Array.isArray(company.children)){
                    return list.concat([company], company.children);
                } else {
                    return list.concat([company]);
                }
            }, [])
        );
    }

    static getCompanyById(dataSource, id){
        if(!typeUtils.isObject(dataSource)){
            throw new TypeError('The method CompanyHelper.getCompanyById expects the first argument to be of type Object');
        }

        /** If :id matches the supplied :dataSource {Company}, return :dataSource */
        if(dataSource.id === id){ return dataSource; }

        /**
         * If :id does not match the :dataSource {Company}, and :dataSource has children,
         * iterate through children to try and find a match
         */
        if(this.hasChildren(dataSource)){
            return dataSource.children.find(child => child.id === id);
        }

        /** No company matching :id was found */
        return null;
    }

    static addRecentCompany(arr, company){
        let _recentCompanies = arr.filter(c => c.id !== company.id);
        _recentCompanies.unshift(company);
        return _recentCompanies;
    }

    static isDisabled(company, selected){
        return (typeUtils.isObject(company) && typeUtils.isObject(selected)) ?
        company.id === selected.id
            :
            false;
    }

    static getFilterDropdownLabel(context){
        switch(context){
            case filterContext.ALL_COMPANIES:
                return 'All Companies';
            case filterContext.CHILD_COMPANIES:
                return 'Child Companies';
            case filterContext.PARENT_COMPANIES:
                return 'Parent Companies';
            case filterContext.RECENT_COMPANIES:
                return 'Recently Selected';
            case filterContext.VST:
                return 'VitalSource Technologies';
            default:
                return '<Please Choose>';
        }
    }

    /**
     * Manually update Company & Child Company booklist counts
     * @param company :Object
     * @param action :String
     */
    static manuallyUpdateCompanyBooklistCounts(company, action){

        if(typeUtils.isObject(company.booklist_counts) && typeUtils.isNumber(company.booklist_counts.active)){

            if(action === 'INCREMENT'){
                company.booklist_counts.active += 1;
            } else if(action === 'DECREMENT'){
                company.booklist_counts.active -= 1;
            }

            if(this.hasChildren(company)){
                company.children.forEach(child => {
                    if(typeUtils.isObject(child.booklist_counts) && typeUtils.isNumber(child.booklist_counts.active)){
                        if(action === 'INCREMENT'){
                            child.booklist_counts.active += 1;
                        } else if(action === 'DECREMENT'){
                            child.booklist_counts.active -= 1;
                        }
                    }
                });
            }
        }
    }

    /**
     * Does company have children
     * @param company
     * @returns {*|boolean}
     */
    static hasChildren(company){
        return (typeUtils.isObject(company) && (Array.isArray(company.children) && company.children.length > 0));
    }

    /**
     * LocalStorage - Get selected company
     * Note: localStorage['BooklistManager_LoggedInUser_SelectedCompany'] = { userId: selectedCompanyId }
     * - Gets the lastSelectedCompany for the loggedInUser from localStorage
     *
     * @returns {*|number}
     */
    static getRememberedCompany(){
        let loggedInUser = _getLoggedInUser();
        return (typeUtils.isObject(loggedInUser) && typeUtils.isNumber(loggedInUser[BOOKLIST.currentContext.user.id])) ?
            loggedInUser[BOOKLIST.currentContext.user.id]
            :
            0;
    }

    /**
     * LocalStorage - Set selected company
     * Note: localStorage['BooklistManager_LoggedInUser_SelectedCompany'] = { userId: selectedCompanyId }
     * - Sets the selectedCompany for the loggedInUser to localStorage
     * @param id
     */
    static setRememberedCompany(id){
        let loggedInUser = _getLoggedInUser();

        if(!typeUtils.isObject(loggedInUser)){
            loggedInUser = {}
        }
        loggedInUser[BOOKLIST.currentContext.user.id] = id;
        localStorage['BooklistManager_LoggedInUser_SelectedCompany'] = JSON.stringify(loggedInUser);
    }

    /**
     * LocalStorage - Remove selected company
     * Note: localStorage['BooklistManager_LoggedInUser_SelectedCompany'] = { userId: selectedCompanyId }
     * - Deletes the loggedInUser key from the localStorage hash
     */
    static deleteRememberedCompany(){
        let loggedInUser = _getLoggedInUser();

        if(typeUtils.isObject(loggedInUser)){
            delete loggedInUser[BOOKLIST.currentContext.user.id];
        }

        localStorage['BooklistManager_LoggedInUser_SelectedCompany'] = JSON.stringify(loggedInUser);
    }

    /**
     * LocalStorage - Set current company Id
     * - Used to set the id of the company from which a booklist was selected
     * @param id
     */
    static setCurrentCompany(id){
        localStorage['BooklistManager_SelectedCompany'] = id;
    }

    /**
     * LocalStorage - Get current company Id set when the booklist was selected
     * @returns {*}
     */
    static getCurrentCompany(){
        return localStorage['BooklistManager_SelectedCompany'];
    }

}

/**
 * Get LoggedInUser hash from localStorage
 * - Maps loggedInUser.id to selectedCompany.id
 * @returns {*|null}
 * @private
 */
function _getLoggedInUser(){
    return typeUtils.isString(localStorage['BooklistManager_LoggedInUser_SelectedCompany']) ?
        JSON.parse(localStorage['BooklistManager_LoggedInUser_SelectedCompany'])
        :
        null;
}